import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { CreateNotificationTemplateRequest } from './createNotificationTemplate';

export interface UpdateNotificationTemplateRequest
  extends CreateNotificationTemplateRequest {
  changeReason?: string;
}

export interface UpdateNotificationTemplateResponse {
  message: string;
  data: {
    id: string;
    name: string;
    notificationType: string;
    channel: string;
    version: number;
    isActive: boolean;
    updatedAt: string;
  };
}

const updateNotificationTemplate: MutationFunction<
  UpdateNotificationTemplateResponse,
  { id: string; data: UpdateNotificationTemplateRequest }
> = async (args) => {
  if (isMockServices()) {
    return await mock({
      message: 'Notification template updated successfully',
      data: {
        id: args.id,
        name: args.data.name,
        notificationType: args.data.notificationType,
        channel: args.data.channel,
        version: 1,
        isActive: args.data.isActive ?? true,
        updatedAt: new Date().toISOString(),
      },
    });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const response = await authTokenHttp<UpdateNotificationTemplateResponse>(
    `/notification-templates/${args.id}`,
    {
      method: 'PUT',
      body: args.data,
    },
  );

  if (response.data) return response.data;

  throw new Error('Failed to update notification template');
};

export default updateNotificationTemplate;
